import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';

import { TrlFormDropdown, TrlTextField } from '»components/atoms/Inputs';
import { ANGOLAN_IBAN_PREFIX } from '»utils/constants';
import { normalizeIbanWithAngolanPrefix } from '»utils/form';
import { TrlFormattedMessagePlain } from '»utils/i18n';

export const CreateAccountDefaultFields = ({ bankInfo }) => {
  const { setFieldValue } = useFormikContext();

  const blockInvalidChar = (e) => {
    if (['e', 'E', '+', '-', '.'].includes(e.key)) e.preventDefault();
  };

  return (
    <>
      <TrlTextField
        name="taxId"
        label={TrlFormattedMessagePlain({ id: 'TRLT_UI-TAX_ID' })}
        placeholder={TrlFormattedMessagePlain({ id: 'TRLT_UI-TAX_ID' })}
        id="taxId"
        isRequired
      />

      <TrlFormDropdown
        name="bankCode"
        label={TrlFormattedMessagePlain({
          id: 'TRLT_UI-BANKING_INSTITUTION',
        })}
        placeholder={TrlFormattedMessagePlain({
          id: 'TRLT_UI-BANKING_INSTITUTION',
        })}
        options={bankInfo}
        isRequired
        onChangeValue={(event) => {
          const bankIbanCode = bankInfo.find(
            (bank) => bank.value === event.target.value,
          ).bankIbanCode;

          if (bankIbanCode)
            setFieldValue('ibanCode', ANGOLAN_IBAN_PREFIX + bankIbanCode);
        }}
      />

      <TrlTextField
        type="number"
        name="bankAccountNumber"
        label={TrlFormattedMessagePlain({
          id: 'TRLT_UI-BANK_ACCOUNT_NUMBER',
        })}
        placeholder={TrlFormattedMessagePlain({
          id: 'TRLT_UI-BANK_ACCOUNT_NUMBER',
        })}
        id="bankAccountNumber"
        isRequired
        onKeyDown={blockInvalidChar}
        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
      />

      <TrlTextField
        name="ibanCode"
        label={TrlFormattedMessagePlain({ id: 'TRLT_UI-IBAN' })}
        placeholder={TrlFormattedMessagePlain({ id: 'TRLT_UI-IBAN' })}
        id="ibanCode"
        isRequired
        additionalFunc={normalizeIbanWithAngolanPrefix({
          fieldName: 'ibanCode',
          setFieldValue,
        })}
      />
    </>
  );
};

CreateAccountDefaultFields.propTypes = {
  bankInfo: PropTypes.array.isRequired,
};
